import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProDefiniciones } from '@shared/interfaces/request/proDefiniciones';
import { ConceptosService } from '@p-p-portafolio/services/conceptos.service';
import { ProDefinicionesService } from '@p-p-portafolio/services/pro-definiciones.service';
import { TasasService } from '@p-p-portafolio/services/tasas.service';
import { UserService } from '@pages/user/services/user.service';
import { InjectableService } from '@shared/utils/injectable.service';
import { SwalService } from '@shared/utils/swal.service';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { DefinicionesFormComponent } from '../../../definiciones/definiciones-form/definiciones-form.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-def-cargos-cierre',
  templateUrl: './def-cargos-cierre.component.html',
  styleUrls: ['./def-cargos-cierre.component.css']
})
export class DefCargosCierreComponent implements OnInit {
  //#region Varibles

  @Input() modelRecived: ProDefiniciones;
  private _user: string = this._userServices.userCurrent;
  public promocion: string = localStorage.getItem('prom');
  public breakpoint: number;
  public tasas: any[];
  public conceptos: any[];
  public calculate: any[];
  public aplicateTo: any[];
  public calculate2: any[];

  //#region Booleanos
  public formPrincipal: boolean = true;
  public selectTasa: boolean;
  public selectCocepto: boolean;
  public selectCocepto2: boolean;
  public loading: boolean;
  //#endregion

  //#endregion

  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<DefinicionesFormComponent>,
    private _swalService: SwalService,
    private _proDefServices: ProDefinicionesService,
    private _userServices: UserService,
    private _injectServices: InjectableService,
    private _tasasServices: TasasService,
    private _conceptosServices: ConceptosService,
    private renderer: Renderer2,
    private _snackBar: MatSnackBar,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.readCalculate();
    this.readAplicateTo();
    this.readCalculate2();
    this.setForm();
    this.readConceptos();
    this.injectConcepto();
    this.readTasas();
    this.injectTasa();
    this.onBreakPonit();
  }

  form = this._fb.group({
    promocion: [this.promocion],
    numVar: [
      '',
      {
        validators: [Validators.required, this.variableValidation()],
        asyncValidators: [this.singleDefinicion()],
        updateOn: 'blur'
      }
    ],
    descripcion: ['', Validators.required],
    claveTasa: ['', Validators.required],
    valorFijo: ['0.0', Validators.required],
    amortInf: [0],
    amortSup: [0],
    formula: [''],
    porcentaje: ['0.0', Validators.required],
    concepto: ['', Validators.required],
    conceptoAdicional: [0],
    user: this._user,
    // Valores que van en formula
    calculate: [1],
    calculate2: [1],
    aplicateTo: [1]
  });

  //#region ValoresPromocion

  readCalculate() {
    let iTipo: number = 20;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.calculate = res.data;
    });
  }

  readAplicateTo() {
    let iTipo: number = 21;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.aplicateTo = res.data;
    });
  }

  readCalculate2() {
    let iTipo: number = 22;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.calculate2 = res.data;
    });
  }

  //#endregion

  //#region SelectTabla
  readConceptos() {
    this._conceptosServices.getAll().subscribe((res) => {
      this.conceptos = res;
    });
  }

  injectConcepto() {
    this._injectServices.disparadorConcepto.subscribe((res) => {
      if (this.selectCocepto2) this.form.patchValue({ conceptoAdicional: res.model.data });
      else this.form.patchValue({ concepto: res.model.data });
      if (res.model.success) this.changeBoolean('form');
    });
  }

  readTasas() {
    this._tasasServices.read().subscribe((res) => {
      this.tasas = res.data;
    });
  }

  injectTasa() {
    this._injectServices.disparadorTasas.subscribe((res) => {
      this.form.patchValue({ claveTasa: res.model.data });
      if (res.model.success) this.changeBoolean('form');
    });
  }
  //#endregion

  //#region ChangeForm

  changeBoolean(change: string) {
    switch (change) {
      case 'form':
        this.selectCocepto = false;
        this.selectCocepto2 = false;
        this.selectTasa = false;
        this.formPrincipal = true;
        break;
      case 'conceptos':
        this.formPrincipal = false;
        this.selectCocepto = true;
        break;
      case 'tasas':
        this.formPrincipal = false;
        this.selectTasa = true;
        break;
      case 'conceptos2':
        this.formPrincipal = false;
        this.selectCocepto = true;
        this.selectCocepto2 = true;
        break;
    }
  }

  //#endregion

  //#region CRUD

  create(model: ProDefiniciones) {
    if (this.form.valid) {
      this.loading = true;
      model = { ...model, formula: this.setFormula() };
      this._proDefServices.create(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else this._swalService.error('No Agregado');
      });
    }
  }

  update(model: ProDefiniciones) {
    if (this.form.valid) {
      this.loading = true;
      model = { ...model, formula: this.setFormula() };
      this._proDefServices.update(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else this._swalService.error('No Editado');
      });
    }
  }

  //#endregion

  //#region Get Fb

  formValue(value: string) {
    return this.form.get(value);
  }

  //#endregion

  //#region Validations
  variableValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const variable = control.value;
      if (variable == null || variable === '') return null;
      if (variable >= 501 && variable <= 600) {
        return null;
      }

      this._snackBar.open('El rango de variables para Cargos Cierre es de 501 a 600', 'cerrar', { duration: 5000 });
      const input = this.el.nativeElement.querySelector('#numVar');
      if (input) {
        this.renderer.addClass(input, 'is-invalid');
      }

      return { variableValidation: true };
    };
  }

  //#endregion

  //#region AsyncValidations
  singleDefinicion(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | any> => {
      if (this.modelRecived) return of(null);

      return this._proDefServices.readOne(this.promocion, control.value).pipe(
        tap(() => {
          const input = this.el.nativeElement.querySelector('#numVar');
          this.renderer.removeClass(input, 'is-invalid');
        }),
        map((res) => {
          const input = this.el.nativeElement.querySelector('#numVar');
          // 1 → la promoción no existe  ⇒  VÁLIDA
          if (res.exito === 1) {
            this.renderer.addClass(input, 'is-invalid'); // aura roja
            this._snackBar.open('Variable en uso, intente con otra.', 'cerrar', { duration: 5000 });
            return { singleDefinicion: true }; // ← objeto de error
          }
          // distinto de 1 → libre  ⇒  INVÁLIDA
          return null; // ← sin errores
        })
      );
    };
  }
  //#endregion

  //#region Options

  setFormula(): string {
    let sep = '|';
    let calculate = this.form?.controls.calculate.value;
    let aplicateTo = this.form?.controls.aplicateTo.value;
    let calculate2 = this.form?.controls.calculate2.value;

    let lst = calculate + sep + aplicateTo + sep + calculate2 + sep;

    // this.form.patchValue({ formula: lst });

    return lst;
  }

  getFormula(formula: string): void {
    let formulaSep: string[] = formula.split('|');
    const setFormula = {
      // Valores que van en formulas
      calculate: Number(formulaSep[0]),
      aplicateTo: Number(formulaSep[1]),
      calculate2: Number(formulaSep[2])
    };
    this.form.patchValue(setFormula);
  }

  setForm(): void {
    if (this.modelRecived !== null) {
      let model: ProDefiniciones = this.modelRecived;
      this.getFormula(model.formula);
      const setModel = {
        promocion: model.promocion,
        numVar: model.numVar,
        descripcion: model.descripcion,
        claveTasa: model.claveTasa,
        valorFijo: model.valorFijo,
        amortInf: 0,
        amortSup: 0,
        formula: model.formula,
        porcentaje: model.porcentaje,
        concepto: model.concepto,
        conceptoAdicional: model.conceptoAdicional,
        user: this._user
      };
      this.form.patchValue(setModel);
    }
  }

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 400 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 400 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }

  //#endregion
}
